let authToken: string | null = null;

export const setAuthToken = (token: string) => {
    try {
        localStorage.setItem('token', token);
        authToken = token;
    } catch (e) {
        console.error('Failed to save token to localStorage:', e);
        authToken = token; // Keep in memory even if localStorage fails
    }
};

export const getAuthToken = (): string | null => {
    if (authToken) return authToken;
    
    try {
        const token = localStorage.getItem('token');
        if (token) {
            authToken = token;
            return token;
        }
    } catch (e) {
        console.error('Failed to read token from localStorage:', e);
    }
    
    return null;
};

export const clearAuthToken = () => {
    try {
        localStorage.removeItem('token');
        localStorage.removeItem('selectedOrganization');
    } catch (e) {
        console.error('Failed to remove data from localStorage:', e);
    }
    authToken = null;
};

export const getSelectedOrganization = () => {
    try {
        const org = localStorage.getItem('selectedOrganization');
        return org ? JSON.parse(org) : null;
    } catch (e) {
        console.error('Failed to read organization from localStorage:', e);
        return null;
    }
};

export const setSelectedOrganization = (organization: any) => {
    try {
        localStorage.setItem('selectedOrganization', JSON.stringify(organization));
    } catch (e) {
        console.error('Failed to save organization to localStorage:', e);
    }
};
